import React from 'react';
import { Link } from 'react-router-dom';
import { FaFileAlt, FaArrowLeft } from 'react-icons/fa';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Back Button */}
        <Link to="/" className="inline-flex items-center gap-2 text-pink-500 mb-6 hover:gap-3 transition-all duration-300">
          <FaArrowLeft size={14} />
          Back to Home
        </Link>

        {/* Header */}
        <div className="bg-white rounded-2xl shadow-xl p-8 mb-6">
          <div className="flex items-center gap-4 mb-4">
            <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
              <FaFileAlt className="text-blue-500 text-xl" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold">
              <span className="bg-gradient-to-r from-pink-500 to-blue-500 bg-clip-text text-transparent">
                Terms & Conditions
              </span>
            </h1>
          </div>
          <p className="text-gray-500 text-sm">Last Updated: {new Date().toLocaleDateString()}</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">1. Acceptance of Terms</h2>
            <p className="text-gray-600 leading-relaxed">
              By accessing and using the Home Fashion Varanasi website, you accept and agree to be bound by these Terms and Conditions. If you do not agree to these terms, please do not use our website.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">2. Products and Pricing</h2>
            <p className="text-gray-600 leading-relaxed mb-2">
              We strive to display accurate product information and pricing. However, we reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
              <li>All prices are in Indian Rupees (₹) and include applicable taxes</li>
              <li>Product availability is subject to change without notice</li>
              <li>We reserve the right to limit quantities of any product</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">3. Orders and Payment</h2>
            <p className="text-gray-600 leading-relaxed mb-2">When you place an order:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
              <li>You confirm that all information provided is accurate and complete</li>
              <li>You authorize us to charge your payment method for the total order amount</li>
              <li>We reserve the right to cancel any order for any reason</li>
              <li>Order confirmation emails do not constitute acceptance of your order</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">4. Shipping and Delivery</h2>
            <p className="text-gray-600 leading-relaxed">
              We offer free delivery within Varanasi city. Delivery times are estimates and not guaranteed. Risk of loss passes to you upon delivery. You are responsible for providing accurate delivery information.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">5. Returns and Refunds</h2>
            <p className="text-gray-600 leading-relaxed mb-2">Our return policy:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-1 ml-4">
              <li>Returns accepted within 7 days of delivery</li>
              <li>Items must be unused and in original packaging</li>
              <li>Refunds processed within 5-7 business days after inspection</li>
              <li>Customized items cannot be returned</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">6. User Accounts</h2>
            <p className="text-gray-600 leading-relaxed">
              You are responsible for maintaining the confidentiality of your account credentials. You agree to notify us immediately of any unauthorized use of your account. We are not liable for any loss or damage from unauthorized use.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">7. Intellectual Property</h2>
            <p className="text-gray-600 leading-relaxed">
              All content on this website, including images, text, logos, and designs, is the property of Home Fashion Varanasi and is protected by copyright laws. You may not use, reproduce, or distribute any content without written permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">8. Limitation of Liability</h2>
            <p className="text-gray-600 leading-relaxed">
              Home Fashion Varanasi shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of our website or products. Our total liability shall not exceed the amount you paid for the products.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">9. Governing Law</h2>
            <p className="text-gray-600 leading-relaxed">
              These terms shall be governed by and construed in accordance with the laws of India. Any disputes shall be subject to the exclusive jurisdiction of the courts in Varanasi, Uttar Pradesh.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">10. Promotional Communications</h2>
            <p className="text-gray-600 leading-relaxed font-medium">
              I hereby agree to receive promotional messages through WhatsApp/RCS/SMS.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">11. Contact Information</h2>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg">
              <p className="text-gray-700"><strong>Home Fashion Varanasi</strong></p>
              <p className="text-gray-600 text-sm">Rathyatra-Mahmmoorganj Road, Varanasi - 221010</p>
              <p className="text-gray-600 text-sm">Phone: +91 8573035759</p>
              <p className="text-gray-600 text-sm">Email: legal@homefashion.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;